<template>
  <div class="app_main">
    <div class="banner">
      <picture>
        <source
          media="(max-width: 768px)"
          srcset="@/assets/images/products/medical/banner_m.png"
        />
        <img src="@/assets/images/products/medical/banner.png" alt="豫知科技" />
      </picture>
      <!-- <div class="p_banner_des">
        <p>产品与方案</p>
        <p class="p_banner_des_sub">
          致力于提升我国医源性感染科室的感染风控能力
        </p>
      </div> -->
    </div>
    <div class="medical_1 xgn margin_t">
      <div class="title"></div>
      <div class="base_layout">
        <div class="medical_1_content xgn_content">
          <p
            class="wow animate__animated animate__fadeIn"
            data-wow-delay="0.8s"
            data-wow-duration="1.2s"
          >
            实现医院感染危险因素对“消毒数据”客观、<br />真实、有效的要求，确保数据的实时性和可<br />追溯性。
          </p>
        </div>
      </div>
    </div>
    <div class="medical_2 margin_t">
      <div class="title"></div>
      <div class="cpld_bg">
        <div class="base_layout">
          <div class="cpld">
            <div class="box">
              <div class="item">
                <img
                  src="@/assets/images/products/medical/cp_icon_1.png"
                  alt="实时监测"
                />
                <p>实时监测</p>
              </div>
            </div>
            <div class="box">
              <div class="item">
                <img
                  src="@/assets/images/products/medical/cp_icon_2.png"
                  alt="预警召回"
                />
                <p>预警召回</p>
              </div>
            </div>
            <div class="box">
              <div class="item">
                <img
                  src="@/assets/images/products/medical/cp_icon_3.png"
                  alt="降低风险"
                />
                <p>降低风险</p>
              </div>
            </div>
            <div class="box">
              <div class="item">
                <img
                  src="@/assets/images/products/medical/cp_icon_4.png"
                  alt="风险上报"
                />
                <p>风险上报</p>
              </div>
            </div>
            <div class="box">
              <div class="item">
                <img
                  src="@/assets/images/products/medical/cp_icon_5.png"
                  alt="过程追溯"
                />
                <p>过程追溯</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="base_layout">
        <div class="medical_4">
          <div class="heard">统一入口</div>
          <div class="content_box">
            <div class="box1">
              <div class="box1_c">医护WEB</div>
              <div class="box1_c">医护移动端</div>
              <div class="box1_c">管理后台</div>
              <div class="box1_c">监控大屏</div>
              <div class="box1_c">数据中心</div>
            </div>
            <div class="box2">
              <h3>MIM系统</h3>
              <div class="main_box2">
                <div class="box2_c">医院详情</div>
                <div class="box2_c">耗材管理</div>
                <div class="box2_c">流程管理</div>
                <div class="box2_c">指标监测</div>
                <div class="box2_c">身份识别</div>
                <div class="box2_c">监控大屏</div>
                <div class="box2_c">患者MPI</div>
                <div class="box2_c">疾控资讯</div>
                <div class="box2_c">机构管理</div>
                <div class="box2_c">设备管理</div>
                <div class="box2_c">预警通知</div>
                <div class="box2_c">动作识别</div>
                <div class="box2_c">数据统计</div>
                <div class="box2_c">业务操作库</div>
              </div>
            </div>
            <div class="box3">
              <div class="box3_c">标准操作规程评估模型</div>
              <div class="box3_c">风险分析模型</div>
              <div class="box3_c">感染预警模型</div>
              <div class="box3_c">干预策略模型</div>
            </div>
            <div class="box4">
              <h3>平台支撑</h3>
              <div class="main_box4">
                <div class="box4_c">物联网平台</div>
                <div class="box4_c">HIS/PHIS</div>
                <div class="box4_c">LIS</div>
                <div class="box4_c">PACS</div>
                <div class="box4_c">厂商系统对接</div>
              </div>
            </div>
            <div class="box5">
              <h3>医院消毒规范</h3>
              <div class="main_box5">
                <div class="box5_c">卫生标准</div>
                <div class="box5_c">监测标准</div>
                <div class="box5_c">管理规范</div>
                <div class="box5_c">技术规范</div>
                <div class="box5_c">操作规范</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="medical_3 margin_t">
      <div class="title"></div>
      <div class="content">
        <div
          class="content_r wow animate__animated animate__fadeInRight"
          data-wow-delay="0.6s"
          data-wow-duration="1.2s"
        >
          以建立医院四大重点院感监管科室的各类医疗操作行为档案为核心，以硬件采集的医疗设备运行数据和医疗环境数据为基础，对整体医疗环节中可能存在的医源性感染风险进行分析模型评估。为各级“院感”监管部门提供数据、服务及决策支撑。
          <ul class="medical_3_ul">
            <li>手术室实时追溯系统</li>
            <li>消毒供应中心追溯系统</li>
            <li>内镜追溯管理系统</li>
            <li>透析室监测管理系统</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="medical_5">
      <div class="base_layout">
        <div class="heard">手术室实时追溯系统</div>
        <div class="medical_img">
          <img
            src="@/assets/images/products/medical/medical_5_2.png"
            class="wow animate__animated animate__zoomIn"
            data-wow-delay="1.2s"
            data-wow-duration="1.2s"
            alt=""
          />
        </div>
        <div class="medical_5_c">
          <div class="medical_5_c_l">管控范围</div>
          <div class="medical_5_c_r">
            <div class="r_c">组织管理要求</div>
            <div class="r_c">工作人员管理</div>
            <div class="r_c">环境管理</div>
            <div class="r_c">消毒隔离管理</div>
            <div class="r_c">无菌物品管理</div>
            <div class="r_c">器械物品处理管理</div>
            <div class="r_c">医院感染监测</div>
            <div class="r_c">医疗废物管理</div>
          </div>
        </div>
      </div>
    </div>
    <div class="medical_6">
      <div class="base_layout">
        <div class="heard">消毒供应中心追溯系统</div>
      </div>
      <div class="medical_img">
        <div class="base_layout">
          <img
            src="@/assets/images/products/medical/medical_6_2.png"
            class="wow animate__animated animate__zoomIn"
            data-wow-delay="1.2s"
            data-wow-duration="1.2s"
            alt=""
          />
        </div>
      </div>
      <div class="base_layout">
        <div class="medical_6_c">
          <div class="medical_6_c_l">管控范围</div>
          <div class="medical_6_c_r">
            <div class="r_c">管理要求</div>
            <div class="r_c">布局流程环境</div>
            <div class="r_c">设备、设施及耗材</div>
            <div class="r_c">质量控制及可追溯记录</div>
            <div class="r_c">清洗消毒及灭菌效果监测</div>
            <div class="r_c">外来器械及植入物管理</div>
          </div>
        </div>
      </div>
    </div>
    <div class="medical_7">
      <div class="base_layout">
        <div class="heard">透析室监测管理系统</div>
        <div class="medical_img">
          <img
            src="@/assets/images/products/medical/medical_7_2.png"
            class="wow animate__animated animate__zoomIn"
            data-wow-delay="1.2s"
            data-wow-duration="1.2s"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="medical_8">
      <div class="base_layout">
        <div class="heard">腔镜追溯管理系统</div>
      </div>
      <div class="medical_8_box">
        <div class="base_layout">
          <div class="box1">
            <div class="box_title">业务层</div>
            <div class="box1_c">
              <div class="item">腔镜洗消管理</div>
              <div class="item">腔镜存储管理</div>
              <div class="item">患者管理</div>
              <div class="item">质量管理</div>
              <div class="item">腔镜信息管理</div>
              <div class="item">标准规范管理</div>
              <div class="item">医护管理</div>
              <div class="item">数据统计</div>
            </div>
          </div>
          <div class="box2">
            <div class="box_title">逻辑层</div>
            <div class="box2_c">
              <div class="item">标准操作规程评估模型</div>
              <div class="item">异常预警模型</div>
              <div class="item">干预策略模型</div>
            </div>
            <div class="box2_m_c">
              <div class="item">标准操作规程<br />评估模型</div>
              <div class="item">异常<br />预警模型</div>
              <div class="item">干预<br />策略模型</div>
            </div>
          </div>
          <div class="box1">
            <div class="box_title">采集层</div>
            <div class="box1_c">
              <div class="item">环境设备监测传感器</div>
              <div class="item">基础信息数据</div>
              <div class="item">医护录入数据</div>
              <div class="item">流程管理数据</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "@/utils/wow.js";
export default {
  mounted() {
    this.$nextTick(() => {
      new WOW().init();
    });
  },
};
</script>
